module.exports = __webpack_public_path__ + "static/subpages-style-header.e8e06f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/desktop/subpages-style-header.jpg
// module id = 590
// module chunks = 168179225184413